import { create } from 'zustand';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

interface User {
  id: number;
  firebase_uid: string;
  email: string;
  display_name: string | null;
  photo_url: string | null;
  preferred_language: string;
}

export interface Subscription {
  id: number;
  status: string;
  end_date: string;
  plan: {
    name: string;
    name_ar: string;
    question_limit: number | null;
    has_full_access: number;
    has_analytics: number;
    has_priority_support: number;
  };
  daysRemaining: number | null;
  isExpired: boolean;
}

interface AuthState {
  user: User | null;
  subscription: Subscription | null;
  isAdmin: boolean;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  setSubscription: (sub: Subscription | null) => void;
  setIsAdmin: (isAdmin: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  subscription: null,
  isAdmin: false,
  isLoading: true,
  setUser: (user) => set({ user }),
  setSubscription: (subscription) => set({ subscription }),
  setIsAdmin: (isAdmin) => set({ isAdmin }),
  logout: () => {
    signOut(auth).catch(() => undefined);
    localStorage.removeItem('token');
    set({ user: null, subscription: null, isAdmin: false });
  },
}));
